import type { ScopedProjectRef } from "@afar-research/contracts";
import { create } from "zustand";

/**
 * Which project's Project Study dialog is open. The sidebar and the empty
 * thread open it; `ProjectStudyCoordinator` renders it and opens it on its own
 * once the project's first ingest completes.
 */
interface ProjectStudyDialogStore {
  readonly target: ScopedProjectRef | null;
  readonly open: (project: ScopedProjectRef) => void;
  readonly close: () => void;
}

export const useProjectStudyDialogStore = create<ProjectStudyDialogStore>((set) => ({
  target: null,
  open: (project) => set({ target: project }),
  close: () => set({ target: null }),
}));
